module.exports = __webpack_public_path__ + "static/media/4cocci2yeast.47894139.jpg";